<h1 mat-dialog-title>Selecciona la caja a inspeccionar</h1>

<div mat-dialog-content class="tw-min-w-96">
  <form
    [formGroup]="form"
    class="
      tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-p-5
    "
  >
    <mat-form-field class="tw-w-full">
      <mat-label>Selecciona la caja</mat-label>
      <mat-select formControlName="selectedBox">
        <mat-option *ngFor="let box of boxes" [value]="box">
          ID#{{ box.id }} - {{ box.createdAt | date: "medium" }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="warn" (click)="onClickClose()">
    Cancelar
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onClickConfirm()"
    class="tw-bg-green-300"
  >
    Confirmar
  </button>
</div>

<div mat-dialog-actions></div>
